import * as Types from './types';
import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

import * as constants from './constants';

export const MFA = ({ config }: Types.MFAOptions) => {
    const {
        caf: {
            enabled: cafEnabled = false,
            sdkUrl: cafSdkUrl = ''
        },
        unico: {
            enabled: unicoEnabled = false,
            sdkUrl: unicoSdkUrl = ''
        }
    } = config;

    useEffect(() => {
        if (!cafEnabled) {
            return;
        }

        window['@combateafraude/identity-sdk-url'] = cafSdkUrl;
    }, [cafEnabled, cafSdkUrl]);

    useEffect(() => {
        if (!unicoEnabled) {
            return;
        }

        window[constants.UNICO_SDK_KEY] = unicoSdkUrl;
    }, [unicoEnabled, unicoSdkUrl]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.mfa]: MFA });
